/*eslint-disable*/
import React from "react";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

class UserHeader extends React.PureComponent {
  render() {
    return (
      <>
        <div
          className="bg-gradient-default header pb-5 pt-7 pt-lg-5 d-flex align-items-center"
          style={{
            minHeight: "100px",
            // eslint-disable-next-line global-require
            backgroundSize: "cover",
            backgroundPosition: "center top",
          }}
        >
          {/* Mask */}
          <span className="mask bg-gradient-default opacity-8" />
          {/* Header container */}
          <Container className="d-flex align-items-center" fluid>
            <Row>
              <Col lg="7" md="10">
                {/* <Button
                  color="info"
                  href="#pablo"
                  onClick={(e: { preventDefault: () => any; }) => e.preventDefault()}
                >
                  Add User
                </Button> */}
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default UserHeader;
